module.exports = __webpack_public_path__ + "img/074-kazakhstan.23430419.svg";